/* eslint-disable no-underscore-dangle */
import i18n from 'i18next';
import { captureException } from '@sentry/browser';

import i18nConfig from '../i18nConfig';

i18n.init(
  {
    ...i18nConfig,
  },
  error => {
    if (error) {
      captureException(error);
    }
  },
);

i18n.changeLanguage(window.__i18n.locale);

i18n.addResourceBundle(
  window.__i18n.locale,
  'common',
  window.__i18n.resources,
  true,
);

export default i18n;
